import type { ComponentTheme } from '../types/component-theme';

import { navigationToggleLinesStyles } from '../shared-styles';

const burgerLineStyles = 'h-0.5 w-full rounded-full bg-gray-500';
const animatedBurgerLineStyles = `${burgerLineStyles} origin-left transition-transform duration-300 ease-out`;

export default {
    slots: {
        root:
            'relative flex h-22.5 w-full shrink-0 items-center justify-between border-b ' +
            'border-b-(--slate-muted-alpha-12) bg-transparent px-8',
        left: 'flex flex-row items-center gap-x-6',
        toggleMotion: 'flex shrink-0',
        toggleButton: 'size-10! shrink-0',
        toggleLabel: 'sr-only',
        burger: navigationToggleLinesStyles,
        burgerLine: burgerLineStyles,
        burgerLineSecond: animatedBurgerLineStyles,
        burgerLineThird: animatedBurgerLineStyles
    },
    variants: {
        sidebarOpen: {
            true: {
                burgerLineSecond: 'scale-x-100',
                burgerLineThird: 'scale-x-100'
            },
            false: {
                burgerLineSecond: 'scale-x-50',
                burgerLineThird: 'scale-x-[0.25]'
            }
        }
    }
} satisfies ComponentTheme;
